<template>
    <div class="training-container bg-gray-50 min-h-screen lg:p-4 lg:px-[20%]">
        <div v-if="isSmallScreen">
            <!-- 顶部状态栏 -->
            <div class="status-bar flex justify-between items-center mb-6">
                <div class="flex items-center">
                    <i class="fas fa-comment-dots text-blue-500"></i>
                    <span class="ml-2">您与AI来访对话{{ consultation_once ? consultation_once  : '--' }}次</span>
                </div>
            </div>

            <!-- 技巧训练模块 -->
            <div class="training-section mb-6">
                <div class="flex justify-between items-center mb-4">
                    <h2 class="text-lg font-semibold">技巧专项训练</h2>
                    <span class="text-blue-500">更多 ></span>
                </div>

                <div class="grid grid-cols-2 gap-4">
                    <!-- 倾听模块 -->
                    <div class="skill-card bg-purple-50 p-4 rounded-lg relative ">
                        <div class="flex flex-row justify-between items-center">
                            <div class="mt-2">
                                <h3 class="font-medium">倾听</h3>
                                <p class="text-xs text-gray-500">LISTEN FOR</p>
                            </div>
                            <div class="p-2 bg-purple-200 rounded-full flex items-center justify-center">
                                <i class="fas fa-headphones text-blue-500"></i>
                            </div>
                        </div>
                        <span class="absolute top-0 right-0 bg-gray-300 text-gray-600 text-xs px-2 py-1 rounded">
                            暂未上线
                        </span>
                    </div>
                    <!-- 重复模块 -->
                    <div class="skill-card bg-purple-50 p-4 rounded-lg relative">
                        <div class="flex  flex-row  justify-between items-center">
                            <div  class="mt-2">
                                <h3 class="font-medium">重复</h3>
                                <p class="text-xs text-gray-500">ENCOURAGE</p>
                            </div>
                            <div class="p-2 bg-purple-200 rounded-full flex items-center justify-center">
                                <i class="fas fa-redo text-purple-500"></i>
                            </div>
                        </div>
                        <span class="absolute top-0 right-0 bg-gray-300 text-gray-600 text-xs px-2 py-1 rounded">
                            暂未上线
                        </span>
                    </div>

                    <!-- 提问模块 -->
                    <div class="skill-card bg-green-50 p-4 rounded-lg relative">
                        <div class="flex  flex-row  justify-between items-center">
                            <div class="mt-2">
                                <h3 class="font-medium">提问</h3>
                                <p class="text-xs text-gray-500">PUT QUESTIONS</p>
                            </div>
                            <div class="p-2 w-8 bg-green-200 rounded-full flex items-center justify-center">
                                <i class="fas fa-question text-green-500"></i>
                            </div>
                        </div>
                        <span class="absolute top-0 right-0 bg-gray-300 text-gray-600 text-xs px-2 py-1 rounded">
                            暂未上线
                        </span>
                    </div>

                    <!-- 共情模块 -->
                    <div class="skill-card bg-teal-50 p-4 rounded-lg relative">
                        <div class="flex  flex-row justify-between items-center">
                            <div class="mt-2">
                                <h3 class="font-medium">共情</h3>
                                <p class="text-xs text-gray-500">ENGAGEMENT</p>
                            </div>
                            <div class="p-2 bg-teal-200 rounded-full flex items-center justify-center">
                                <i class="fas fa-heart text-teal-500"></i>
                            </div>
                        </div>
                        <span class="absolute top-0 right-0 bg-gray-300 text-gray-600 text-xs px-2 py-1 rounded">
                            暂未上线
                        </span>
                    </div>
                </div>
            </div>

            <!-- 咨询类型 -->
            <div class="consultation-types">
                <!-- 单次咨询 -->
                <div class="consultation-card bg-white p-4 rounded-lg mb-4 shadow-sm" @click="longConversion">
                    <div class="flex justify-between lg:items-center sm:items-left">
                        <div class="mt-2">
                            <h3 class="font-medium">单次咨询</h3>
                            <p class="text-xs text-gray-500 mt-1">与您的来访进行单次咨询训练</p>
                            <p class="text-xs text-gray-500">适合任意阶段咨询师</p>
                        </div>
                        <div class="text-gray-400">
                            已对话  {{ consultation_once ?  consultation_once  : '--' }} 次
                        </div>
                    </div>
                </div>

                <!-- 长程咨询 -->
                <div class="consultation-card bg-white p-4 rounded-lg shadow-sm relative">
                    <div class="flex justify-between  sm:items-left">
                        <div>
                            <h3 class="font-medium">长程咨询</h3>
                            <p class="text-xs text-gray-500 mt-1">与您的来访进行6-25次的连续咨询训练</p>
                            <p class="text-xs text-gray-500">适合任意阶段咨询师</p>
                        </div>
                        <div class="text-gray-400">
                            {{ consultation_long ? '已对话' + consultation_long + '次' : '--' }}
                        </div>
                    </div>
                    <span class="absolute top-0 right-0 bg-gray-300 text-gray-600 text-xs px-2 py-1 rounded">
                        暂未上线
                    </span>
                </div>
            </div>
        </div>
        <div v-else>
            <!-- 顶部状态栏 -->
            <div class="status-bar flex justify-between items-center mb-6">
                <div class="flex items-center">
                    <i class="fas fa-comment-dots text-blue-500"></i>
                    <span class="ml-2">您与AI来访对话{{ consultation_once ? consultation_once  : '--' }}次</span>
                </div>
            </div>

            <!-- 技巧训练模块 -->
            <div class="training-section mb-6">
                <div class="flex justify-between items-center mb-4">
                    <h2 class="text-lg font-semibold">技巧专项训练</h2>
                    <span class="text-blue-500">更多 ></span>
                </div>

                <div class="grid grid-cols-2 gap-4">
                    <!-- 倾听模块 -->
                    <div class="skill-card flex justify-between items-center relative">
                        <span class="absolute right-0 top-0 bg-gray-300 text-gray-600 text-xs px-2 py-1 rounded">
                            暂未上线
                        </span>
                        <div>
                            <h3 class="font-medium ">倾听</h3>
                            <p class="text-xs text-gray-500">LISTEN FOR</p>
                        </div>
                        <div class="w-8 h-8 bg-blue-200 rounded-full flex items-center justify-center">
                            <i class="fas fa-headphones text-blue-500"></i>
                        </div>
                    </div>

                    <!-- 重复模块 -->
                    <div class="skill-card bg-purple-50 p-4 rounded-lg relative">
                        <div class="flex justify-between items-center">
                            <div>
                                <h3 class="font-medium">重复</h3>
                                <p class="text-xs text-gray-500">ENCOURAGE</p>
                            </div>
                            <div class="w-8 h-8 bg-purple-200 rounded-full flex items-center justify-center">
                                <i class="fas fa-redo text-purple-500"></i>
                            </div>
                        </div>
                        <span class="absolute top-0 right-0 bg-gray-300 text-gray-600 text-xs px-2 py-1 rounded">
                            暂未上线
                        </span>
                    </div>

                    <!-- 提问模块 -->
                    <div class="skill-card bg-green-50 p-4 rounded-lg relative">
                        <div class="flex justify-between items-center">
                            <div>
                                <h3 class="font-medium">提问</h3>
                                <p class="text-xs text-gray-500">PUT QUESTIONS</p>
                            </div>
                            <div class="w-8 h-8 bg-green-200 rounded-full flex items-center justify-center">
                                <i class="fas fa-question text-green-500"></i>
                            </div>
                        </div>
                        <span class="absolute top-0 right-0 bg-gray-300 text-gray-600 text-xs px-2 py-1 rounded">
                            暂未上线
                        </span>
                    </div>

                    <!-- 共情模块 -->
                    <div class="skill-card bg-teal-50 p-4 rounded-lg relative">
                        <div class="flex justify-between items-center">
                            <div>
                                <h3 class="font-medium">共情</h3>
                                <p class="text-xs text-gray-500">ENGAGEMENT</p>
                            </div>
                            <div class="w-8 h-8 bg-teal-200 rounded-full flex items-center justify-center">
                                <i class="fas fa-heart text-teal-500"></i>
                            </div>
                        </div>
                        <span class="absolute top-0 right-0 bg-gray-300 text-gray-600 text-xs px-2 py-1 rounded">
                            暂未上线
                        </span>
                    </div>
                </div>
            </div>

            <!-- 咨询类型 -->
            <div class="consultation-types">
                <!-- 单次咨询 -->
                <div class="consultation-card bg-white p-4 rounded-lg mb-4 shadow-sm" @click="longConversion">
                    <div class="flex justify-between lg:items-center sm:items-left">
                        <div>
                            <h3 class="font-medium">单次咨询</h3>
                            <p class="text-xs text-gray-500 mt-1">与您的来访进行单次咨询训练</p>
                            <p class="text-xs text-gray-500">适合任意阶段咨询师</p>
                        </div>
                        <div class="text-gray-400">
                            已对话  {{ consultation_once ?  consultation_once  : '--' }} 次
                        </div>
                    </div>
                </div>

                <!-- 长程咨询 -->
                <div class="consultation-card bg-white p-4 rounded-lg shadow-sm relative">
                    <div class="flex justify-between items-center">
                        <div>
                            <h3 class="font-medium">长程咨询</h3>
                            <p class="text-xs text-gray-500 mt-1">与您的来访进行6-25次的连续咨询训练</p>
                            <p class="text-xs text-gray-500">适合任意阶段咨询师</p>
                        </div>
                        <div class="text-gray-400">
                            {{ consultation_long ? '已对话' + consultation_long + '次' : '--' }}
                        </div>
                    </div>
                    <span class="absolute top-0 right-0 bg-gray-300 text-gray-600 text-xs px-2 py-1 rounded">
                        暂未上线
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
export default {
    name: 'SkillTraining',
    data() {
        return {
            consultation_once:null,
            consultation_long: null,
            isSmallScreen: false
        }
    },
    mounted() {
        this.checkScreenSize();
        window.addEventListener('resize', this.checkScreenSize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkScreenSize);
    },
    methods: {
        checkScreenSize() {
            this.isSmallScreen = window.innerWidth < 768; 
        },
        longConversion() {
            this.$router.push({ name: 'SimulationList' });
        },
        async getLongTrainCnt() {
            const token = localStorage.getItem('token');
            if (!token) {
                return;
            }
            const params = {
                page: -1,
                type:"long",
            };
            const headers = {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            };
            try {
                const response = await axios.get("/api/train/history/type", { headers, params });
                if (response.status == 200 && response.data.code == "00") {
                    this.consultation_once = response.data.total;
                    console.log(this.consultation_once);
                }
            }  catch(error) {
                console.error('获取对话信息失败:', error);
                throw error; // 向上传递错误
            }
        },
    },
    created() {
        this.getLongTrainCnt();
    }
}
</script>

<style scoped>
.skill-card {
  transition: all 0.3s ease;
}

.skill-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.consultation-card {
  transition: all 0.3s ease;
}

.consultation-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}


</style>